@if (resources().length > 0) {
  <div
    class="flex gap-2 mb-1 overflow-x-auto pb-1 w-full"
    [class.flex-row-reverse]="alignEnd()"
  >
    @for (resource of resources(); track resource.id) {
      @if (isPdf(resource.mimeType)) {
        <!-- PDF attachment -->
        <button
          type="button"
          (click)="openPreview(resource, $event)"
          class="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors shrink-0 cursor-pointer max-w-24 sm:max-w-32"
        >
          <lucide-icon
            [img]="icons.FileText"
            class="w-5 h-5 text-gray-500 shrink-0"
          ></lucide-icon>
          <span class="text-sm text-gray-700 truncate">{{
            resource.originalName
          }}</span>
        </button>
      } @else {
        <!-- Image attachment -->
        <button
          type="button"
          (click)="openPreview(resource, $event)"
          class="block rounded-lg overflow-hidden border border-gray-200 hover:border-gray-300 transition-colors shrink-0 cursor-pointer"
        >
          <img
            [src]="getResourceUrl(resource)"
            [alt]="resource.originalName"
            class="w-24 h-24 sm:w-32 sm:h-32 object-cover"
            loading="lazy"
          />
        </button>
      }
    }
  </div>
}

<!-- Image preview modal -->
<app-image-preview-modal
  [previewItem]="previewItem"
  (closed)="closePreview()"
/>
